import axios from 'axios';

export interface WorkTaskFileDto {
  Oid: string;
  WorkTaskOid: string;
  FileName: string;
  ContentType: string;
  FileSize: number;
  UploadedAt: string;
  UploadedBy: string;
}

function getHeaders(token: string) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

/** Return the URL to stream/download a file (use as href or <img src=...>) */
export function getFileUrl(workTaskOid: string, fileId: string): string {
  return `${process.env.REACT_APP_URL}/api/WorkTask/${workTaskOid}/Files/${fileId}`;
}

/** List all files for a work task */
export async function getWorkTaskFiles(token: string, workTaskOid: string): Promise<WorkTaskFileDto[]> {
  const res = await axios.get(
    `${process.env.REACT_APP_URL}/api/WorkTask/${workTaskOid}/Files`,
    getHeaders(token)
  );
  return res.data;
}

/** Upload one or more files (multipart/form-data) */
export async function uploadWorkTaskFiles(
  token: string,
  workTaskOid: string,
  files: File[]
): Promise<WorkTaskFileDto[]> {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));
  const res = await axios.post(
    `${process.env.REACT_APP_URL}/api/WorkTask/${workTaskOid}/UploadFiles`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return res.data;
}

/** Delete a single file */
export async function deleteWorkTaskFile(token: string, workTaskOid: string, fileId: string): Promise<void> {
  await axios.delete(
    `${process.env.REACT_APP_URL}/api/WorkTask/${workTaskOid}/Files/${fileId}`,
    getHeaders(token)
  );
}
